import { ThemeOptions, ThemeContextValues } from '../ThemeContext';

export function setThemeClass(
  context: ThemeContextValues,
  targetEl?: Element
): void {
  const theme = context.theme || null;
  if (!theme) return null;
  const el = targetEl || document.getElementsByTagName('body')[0];
  const themeClass = `${theme}-theme`.toLowerCase();

  if (!el.classList.contains(themeClass)) {
    for (const key in ThemeOptions) {
      const removeClass = `${key}-theme`;
      el.classList.remove(removeClass);
    }
    el.classList.add(themeClass);

    const root = document.documentElement;
    root.dataset.colorScheme = themeClass;
  }

  return null;
}
